<template>
  <div class="header-nav" :class="'theme' + theme">
    <div class="container nav-container clearfix">
      <div class="nav-logo">
        <img :src="logo" class="logo" alt />

        <i
          class="el-icon-location"
          style="font-size: 18px;margin-left: 20px;position: relative;top: 2px;"
        ></i>

        <div style="display:inline-block">
          <el-popover
            placement="bottom"
            width="340"
            trigger="click"
            ref="popover"
          >
            <p class="province-content" style="padding: 10px">
              <el-row :gutter="20">
                <el-col :span="6" v-for="(o, i) in all_province" :key="o">
                  <el-button
                    class="province-item"
                    :class="{ active: active === i }"
                    @click="setProvince(i)"
                    type="text"
                    >{{ i }}
                  </el-button>
                </el-col>
              </el-row>
            </p>
            <el-button slot="reference" type="text">
              {{ active }}&nbsp;<i class="el-icon-arrow-down"></i>
            </el-button>
          </el-popover>
        </div>
      </div>
      <ul class="nav-list clearfix">
        <template v-if="infoLoading">
          <template v-if="user.mobile">
            <!-- <li class="nav-log">
                          <span >退出登录</span>
                        </li> -->
            <li class="nav-dropdown">
              <el-dropdown>
                <span class="el-dropdown-link">
                  <span class="user-logo">
                    <el-image
                      :src="user.user_header"
                      fit="cover"
                      style="height: 100%"
                    >
                      <div slot="error" class="image-slot">
                        <el-image
                          src="https://o.bysjy.com.cn/kzp/public/photo_default.png"
                          fit="cover"
                          style="height: 100%"
                        />
                      </div>
                    </el-image>
                  </span>
                  {{ user.name }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="pageto('m_setting')"
                    >账号设置</el-dropdown-item
                  >
                  <el-dropdown-item @click.native="showLogOutFn"
                    >退出登录</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </template>
          <template v-else>
            <li class="nav-log">
              <a
                href="https://hr.bysjy.com.cn/login/index.html"
                target="kzp_erp"
              >
                <span> <i class="iconfont iconqiye2"></i>企业版 </span>
              </a>
            </li>
            <li class="nav-log">
              <span @click="loginFn">
                <i class="iconfont iconxuesheng2"></i>学生登录
              </span>
            </li>
          </template>
        </template>
        <template v-for="(item, index) in nav.data">
          <li
            class="nav"
            :class="{ active: nav.value == item.value }"
            v-if="item.name !== '个人中心' || user.mobile"
            :key="index"
          >
            <span @click="routerFn(item)">{{ item.name }}</span>
            <i
              class="hot-tip"
              v-if="
                item.value === 'jobfair' ||
                  item.value === 'career_talk' ||
                  item.value === 'offline_jobfair'
              "
              >hot</i
            >
          </li>
        </template>
      </ul>
    </div>
    <a
      ref="subpage"
      :href="subpageData.link"
      :target="subpageData.target"
      style="position: absolute; display: inline-block; height: 0; width: 0"
    ></a>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { routes } from "@/routes/index";
import { province_simple } from "@/datas/area.js";

import Vue from "vue";
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";

Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);

export default {
  name: "header-nav",
  props: {
    theme: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    nav_data() {
      var _self = this;
      var o = {},
        nav_data = this.nav.data;

      var format = function(data, pre_data) {
        data.forEach(item => {
          if (item.link === undefined) {
            return;
          }

          var name = (pre_data && pre_data.value) || item.value;

          o[item.link] = { name: name, data: item };

          if (item.sub) {
            format(item.sub, pre_data || item);
          }
        });
      };

      format(nav_data);

      return o;
    },
    all_province() {
      var obj = { 全国站: "" };
      province_simple.forEach(item => {
        obj[item[1] + "站"] = item[0];
      });
      return obj;
    }
  },
  data() {
    return {
      logo: "https://o.bysjy.com.cn/kzp/kzp_web/yxz-logo.png",
      user_logo: "https://o.bysjy.com.cn/kzp/kzp_web/user_logo.png",
      nav: {
        data: routes,
        value: ""
      },
      subpageData: {
        link: "",
        target: ""
      },
      infoLoading: false,
      active: this.$util.getProvinceConfig()
        ? this.$util.getProvinceConfig() + "站"
        : "全国站"
    };
  },
  created: function() {},
  mounted() {
    this.init();

    var _self = this;

    _self.infoLoading = false;
    this.$util.getInfo().then(res => {
      _self.infoLoading = true;
    });
  },
  methods: {
    pageto: function(value, QueryString) {
      var link = this.$util.page_explain(value, QueryString);

      if (link) {
        location.href = link;
      }
    },
    subpageto: function(value, QueryString, target) {
      var link = this.$util.page_explain(value, QueryString);

      var _self = this;

      if (link) {
        this.subpageData = {
          link: link,
          target: target ? target : "_blank"
        };

        _self.$nextTick(() => {
          if (_self.$refs.subpage) {
            _self.$refs.subpage.click();
          } else {
            console.log("没有点击的地方...");
          }
        });
      }
    },
    init: function() {
      var pathname = window.location.pathname;

      var nav_data = this.nav_data;

      var nav_name = "";
      var check_nav = nav_data[pathname];
      if (check_nav && check_nav.name) {
        nav_name = check_nav.name;
      } else {
        nav_name = "home";
      }

      this.nav.value = nav_name;
    },
    // 路由菜单跳转
    routerFn: function(item) {
      location.href = item.link;
    },
    // 求职者登录
    loginFn: function() {
      this.$store.commit("changeLoginState", [
        {
          key: "is_show_dialog",
          value: true
        },
        {
          key: "is_show_bind_mobile",
          value: false
        }
      ]);
    },
    showLogOutFn: function() {
      this.$store.commit("changeLoginState", {
        key: "is_show_logout",
        value: true
      });
    },
    setProvince: function(i) {
      this.active = i;
      this.$util.setProvinceConfig(i);
      this.$emit("change-province", i);
      this.$refs.popover.doClose();
    }
  }
};
</script>

<style lang="scss" scoped>
.header-nav {
  width: 100%;
  color: #fff;

  .nav-container {
    height: 68px;
    font-size: 14px;
    line-height: 68px;
    text-align: center;
    // overflow: hidden;

    .user-logo {
      display: inline-flex;
      vertical-align: middle;
      width: 30px;
      height: 30px;
      // line-height: 30px;
      text-align: center;
      // background-color: #c0c4cc;
      border: 1px solid #ffffff;

      overflow: hidden;
      @include border-radius(50%);

      img {
        object-fit: cover;
        display: block;
        height: 100%;
        vertical-align: middle;
        cursor: pointer;
      }
    }

    .nav-list,
    .nav-logo {
      float: left;
      height: 100%;
    }

    .nav-logo {
      width: 260px;
      text-align: left;
      .logo {
        height: 28px;
      }
    }

    .nav-list {
      width: 940px;
      text-align: right;
      // overflow: hidden;

      > li {
        position: relative;
        float: right;
        padding: 0 20px;

        .iconfont {
          margin-right: 5px;
        }
      }

      .nav,
      .nav-log {
        span {
          color: #fff;
          display: inline-block;
          cursor: pointer;
          padding: 3px 10px;
          font-size: 14px;
          height: 24px;
          line-height: 24px;
          font-weight: 500;
          @include border-radius(4px);
        }
      }

      .active,
      .nav:hover {
        span {
          background-color: #fff;
          color: #007fff;
        }
      }
    }
  }

  &.theme {
    // border-bottom: 1px solid #fff;
  }

  &.theme1 {
    @include linear-gradient(right, #0080ff, #41a0ff);
  }

  .hot-tip {
    color: #fff;
    position: absolute;
    top: 13px;
    right: 8px;
    padding: 3px;
    border-radius: 5px;
    background: red;
    height: 10px;
    display: block;
    text-align: center;
    line-height: 10px;
    font-size: 12px;
    transform: scale(0.85);
  }

  .nav-dropdown {
    .el-dropdown-link {
      display: block;
      color: #fff;
      cursor: pointer;
    }
  }
}

.el-button--text:focus,
.el-button--text:hover,
.el-button--text {
  color: #ffffff;
}

.province-item {
  cursor: pointer;
  margin: 0;
  color: #333333;

  &.active {
    color: #007fff;
  }

  &:hover {
    color: #007fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/HeaderNav.vue